module.exports = __webpack_public_path__ + "static/ui_ux_photo-211371777d4e5121e18a510ca3880f93.jpg";